import React from 'react';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { CropperModal } from 'components/form/CropperModal/CropperModal';
import { getBaseImageUrl } from 'utils/image';
import { COLLAGE_IMAGE_ASPECT_RATIO } from 'constants/image';

import { CollageImageUpload } from './CollageImageUpload';

type TProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
  error?: string;
  aspectRatio?: number;
};

export class CollageImage extends React.Component<TProps> {
  static defaultProps = {
    onChange: () => undefined,
    value: null,
    aspectRatio: COLLAGE_IMAGE_ASPECT_RATIO,
  };

  state = {
    infoModalIsOpen: false,
    originalImageUrl: null,
    cropModalIsOpen: false,
    croppedImageUrl: null,
  };

  onImageChange = file => {
    this.props.onChange({ file });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        originalImageUrl: this.props.value?.file
          ? this.props.value?.file.image.src
          : getBaseImageUrl(this.props.value),
      });
    }
  }

  onRemoveClick = () => {
    this.props.onChange(null);
  };

  componentDidMount() {
    this.setState({
      originalImageUrl: this.props.value?.file
        ? this.props.value?.file.image.src
        : getBaseImageUrl(this.props.value),
    });
  }

  setCropModalIsOpen(status) {
    this.setState({
      cropModalIsOpen: status,
    });
  }

  setCroppedImageUrl(url) {
    this.setState({
      croppedImageUrl: url,
    });
  }

  render() {
    const { value } = this.props;
    return (
      <CollageImageUpload
        {...this.props}
        onChange={this.onImageChange}
        value={value}
      >
        {Boolean(value) && (
          <React.Fragment>
            <Button
              onClick={() => {
                this.setCropModalIsOpen(true);
              }}
              shape='circle'
              style={{
                position: 'absolute',
                top: '14px',
                left: '14px',
              }}
            >
              <EditOutlined />
            </Button>
            <Button
              onClick={this.onRemoveClick}
              shape='circle'
              icon={<CloseOutlined />}
              style={{
                position: 'absolute',
                top: '14px',
                right: '14px',
              }}
            />
            <CropperModal
              value={value}
              onChange={this.props.onChange}
              setCroppedImageUrl={this.setCroppedImageUrl.bind(this)}
              originalImageUrl={this.state.originalImageUrl}
              setCropModalIsOpen={this.setCropModalIsOpen.bind(this)}
              cropModalIsOpen={this.state.cropModalIsOpen}
              aspectRatio={this.props.aspectRatio}
            />
          </React.Fragment>
        )}
      </CollageImageUpload>
    );
  }
}
